// extracted by mini-css-extract-plugin
module.exports = {"success":"ShopifyUpgradeFeedback_success__glQiO","emoji":"ShopifyUpgradeFeedback_emoji__7yoP6"};